import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Button,
} from "@mui/material";
import { useSchedule } from '../../../contexts/ScheduleContext';


interface AddToGameDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (gameId: number) => void;
  chartName: string;
}

export const AddToGameDialog: React.FC<AddToGameDialogProps> = ({
  open,
  onClose,
  onConfirm,
  chartName,
}) => {
  const [selectedGame, setSelectedGame] = useState<number | null>(null);
  const { games } = useSchedule();
  
  const handleConfirm = () => {
    if (selectedGame) {
      onConfirm(selectedGame);
      setSelectedGame(null);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Depth Chart to Game</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Select a game to add "{chartName}" to:
        </Typography>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="game-select-label">Game</InputLabel>
          <Select
            labelId="game-select-label"
            value={selectedGame ?? ''}
            label="Game"
            onChange={(e) => setSelectedGame(Number(e.target.value))}
          >
            {games.map((game) => (
              <MenuItem key={game.id} value={game.id}>
                {game.opponent_club?.name} vs {game.date}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          disabled={!selectedGame}
          sx={{
            color: "white",
            bgcolor: "rgba(123, 45, 58, 0.9)",
            "&:hover": { bgcolor: "rgba(123, 45, 58, 0.7)" },
            fontWeight: 600,
          }}
        >
          Add to Game
        </Button>
      </DialogActions>
    </Dialog>
  );
};